import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ErrorType } from '../../api/errorHandling';
import { FileType } from '../../types/types';
import { ToastMessageProps } from '../toast/toastSlice';

interface ReportsState {
 report: FileType | null;
 loading?: { [key: string]: boolean | null };
 success?: { [key: string]: boolean | null };
}

interface ReportsGeneratePayload {
 type: 'Word' | 'PdfReport';
 ReportTemplateId: number;
 Copies?: number;
 Id?: number;
 StartDate?: string;
 EndDate?: string;
 ReceiverId?: number;
 ProductId?: number;
 CarId?: number;
 DriverId?: number;
 ProductGroupId?: number;
 CargoType?: number;
 CarrierId?: number;
 SenderId?: number;
}

export interface ReportType {
 Id: number;
 Name: string;
 Group: string;
 Type: string;
 DocumentType: string;
 Info1: string | null;
 Info2: string | null;
 Info3: string | null;
}

export const initialState: ReportsState = {
 report: null,
 loading: {},
 success: {},
};

const reportsSlice = createSlice({
 name: 'reports',
 initialState,
 reducers: {
  reportsGenerateStart(state, action: PayloadAction<ReportsGeneratePayload>) {
   return {
    ...state,
    loading: { ...state.loading, reportsGenerate: true },
   };
  },
  reportsGenerateSuccess(
   state,
   action: PayloadAction<ReportsState & ToastMessageProps>,
  ) {
   return {
    ...state,
    report: action.payload.report,
    success: { ...state.success, reportsGenerate: true },
    loading: { ...state.loading, reportsGenerate: null },
   };
  },
  reportsGenerateFailure(state, action: PayloadAction<ErrorType>) {
   return {
    ...state,
    success: { ...state.success, reportsGenerate: null },
    loading: { ...state.loading, reportsGenerate: null },
   };
  },
  reportsGenerateFinish(state, action: PayloadAction<ErrorType>) {
   return {
    ...state,
    report: null,
    success: { ...state.success, reportsGenerate: null },
    loading: { ...state.loading, reportsGenerate: null },
   };
  },
 },
});
export const {
 reportsGenerateStart,
 reportsGenerateSuccess,
 reportsGenerateFailure,
 reportsGenerateFinish,
} = reportsSlice.actions;
export default reportsSlice.reducer;
